const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M100 0H0V100H100V0Z",
  fill: "#0076FF"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71.7443 52.0368C70.1063 52.0368 68.727 53.4161 68.727 55.0541C68.727 56.692 70.0201 57.9851 71.7443 57.9851C73.3822 57.9851 74.6753 56.692 74.6753 55.0541C74.7615 53.4161 73.3822 52.0368 71.7443 52.0368ZM71.7443 61.261C68.296 61.261 65.4512 58.5023 65.4512 55.0541C65.4512 51.6058 68.296 48.8472 71.7443 48.8472C75.1925 48.8472 77.9512 51.6058 77.9512 55.0541C78.0374 58.5023 75.1925 61.261 71.7443 61.261Z",
  fill: "#F6FAFF"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2788 77.4139H46.0029V66.207H49.2788V77.4139Z",
  fill: "#F6FAFF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M54.02 77.4139H50.7441V66.207H54.02V77.4139Z",
  fill: "#F6FAFF"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M64.3388 28.0968L67.5284 24.9072L65.2008 22.5796L62.0112 25.7693L59.6836 28.0968L63.8215 32.2348L60.6319 35.4244L62.9594 37.752L68.4767 32.2348L64.3388 28.0968Z",
  fill: "#F6FAFF"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0154 54.6873L29.9399 57.9874H26.0881L28.0154 54.6873ZM28.0154 48.2153L20.4424 61.308H35.5883L28.0154 48.2153Z",
  fill: "#F6FAFF"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4065 26.1137L40.0789 23.7861L36.1134 27.7516L32.1479 23.7861L29.8203 26.1137L33.7858 30.0792L29.8203 34.0448L32.1479 36.3723L36.1134 32.4068L40.0789 36.3723L42.4065 34.0448L38.441 30.0792L42.4065 26.1137Z",
  fill: "#F6FAFF"
});
function SvgLogotype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotype);
export default __webpack_public_path__ + "static/media/logotype.a33e79ab.svg";
export { ForwardRef as ReactComponent };